export const getRecipe = state => {
    
    let jsonReqData
    jsonReqData = {
        id: state.props.id,
        supplier_name: state.props.supplier_name,
        contact_person: state.props.contact_person,
        contact_number: state.props.contact_number,
        address: state.props.address,
        bank_details: state.props.bank_details,
        notes: state.props.notes,
        email: state.props.email,
        supplier_type: state.props.supplier_type
    }
    //return
    return jsonReqData

}

export const getRecipeList = state => {
    return state.list    
}


// WEBPACK FOOTER //
// ./src/store/modules/recipe/getters.js